import * as React from "react";
import { cva, VariantProps } from "class-variance-authority";

import { cn } from "src/@/lib/utils";

const alertVariants = cva(
    "relative w-full rounded-lg border p-4 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
    {
        variants: {
            variant: {
                default: "bg-background text-foreground",
                success:
                    "border-[hsl(var(--alert-success))] bg-[hsl(var(--alert-success)/0.1)] text-[hsl(var(--alert-success))] [&>svg]:text-[hsl(var(--alert-success))] [&_button]:border-[hsl(var(--alert-success))] [&_button]:text-[hsl(var(--alert-success))]",
                info: "border-[hsl(var(--alert-info))] bg-[hsl(var(--alert-info)/0.1)] text-[hsl(var(--alert-info))] [&>svg]:text-[hsl(var(--alert-info))] [&_button]:border-[hsl(var(--alert-info))] [&_button]:text-[hsl(var(--alert-info))]",
                warning:
                    "border-[hsl(var(--alert-warning))] bg-[hsl(var(--alert-warning)/0.1)] text-[hsl(var(--alert-warning))] [&>svg]:text-[hsl(var(--alert-warning))] [&_button]:border-[hsl(var(--alert-warning))] [&_button]:text-[hsl(var(--alert-warning))]",
                destructive:
                    "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

const Alert = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
    <div
        ref={ref}
        role="alert"
        className={cn(alertVariants({ variant }), className)}
        {...props}
    />
));
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef<
    HTMLParagraphElement,
    React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
    <h5
        ref={ref}
        className={cn(
            "mb-1 font-medium leading-none tracking-tight",
            className,
        )}
        {...props}
    />
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef<
    HTMLParagraphElement,
    React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn("text-sm [&_p]:leading-relaxed", className)}
        {...props}
    />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
